
import { useContext, useEffect, useRef, useState } from "react";
import cursor_standard from "url:../assets/cursors/DefaultCursor.png";
import cursor_standard_icon from "url:../assets/cursors/DefaultCursor-icon.png";
import cursor_hammer_up from "url:../assets/cursors/HammerCursor.png";
import cursor_hammer_down from "url:../assets/cursors/HammerCursor-down.png";
import cursor_key_1 from "url:../assets/cursors/KeyCursor-gold.png";
import cursor_key_2 from "url:../assets/cursors/KeyCursor-red.png";
import cursor_key_3 from "url:../assets/cursors/KeyCursor-blue.png";
import hammer_sound from "url:../assets/audio/hammer-sfx.mp3";
import cursor_plasma from "url:../assets/cursors/PlasmaCursor.png";
import cursor_yoyo from "url:../assets/cursors/YoYoCursor.png";
import "../styles/mcs.css";
import CursorProvider, { CursorContext, CursorState } from "../providers/CursorProvider";

interface CursorInfo 
{
    name : string;
    key : string;
    icon : string;
    standard : string;
    audio ?: HTMLAudioElement;
    down ?: string;
}

export const CRS_INFO_STD : CursorInfo = {
    name: "Cursor",
    key: "crsstd",
    icon: cursor_standard_icon,
    standard: cursor_standard
};
export const CRS_INFO_HAM : CursorInfo = {
    name: "Hammer",
    key: "crsham",
    icon: cursor_hammer_up,
    standard: cursor_hammer_up,
    down: cursor_hammer_down,
    audio: new Audio(hammer_sound)
};
export const CRS_INFO_PLZ : CursorInfo = {
    name: "Plasma",
    key: "crsplz",
    icon: cursor_plasma,
    standard: cursor_plasma
};
export const CRS_INFO_YYO : CursorInfo = {
    name: "Yo-Yo",
    key: "crsyyo",
    icon: cursor_yoyo,
    standard: cursor_yoyo
};
export const CRS_INFO_KY1 : CursorInfo = { 
    name: "Key 1",
    key: "crsky1", 
    icon: cursor_key_1, 
    standard: cursor_key_1
};
export const CRS_INFO_KY2 : CursorInfo = {
    name: "Key 2",
    key: "crsky2",
    icon: cursor_key_2,
    standard: cursor_key_2
};
export const CRS_INFO_KY3 : CursorInfo = {
    name: "Key 3",
    key: "crsky3",
    icon: cursor_key_3,
    standard: cursor_key_3
};

export const ALL_CRS_INFO : CursorInfo[] = [
    CRS_INFO_STD,
    CRS_INFO_HAM,
    CRS_INFO_PLZ,
    CRS_INFO_YYO,
    CRS_INFO_KY1,
    CRS_INFO_KY2,
    CRS_INFO_KY3
];

export const GetCrsInfo = (state : CursorState) : CursorInfo => 
{
    switch (state)
    {
        case CursorState.STD:
            return CRS_INFO_STD;
        case CursorState.HAM:
            return CRS_INFO_HAM;
        case CursorState.PLZ:
            return CRS_INFO_PLZ;
        case CursorState.YOY:
            return CRS_INFO_YYO;
        case CursorState.KY1:
            return CRS_INFO_KY1;
        case CursorState.KY2:
            return CRS_INFO_KY2;
        case CursorState.KY3:
            return CRS_INFO_KY3;
    }
};

export function GetCrsInfoByKey (key: string) : CursorInfo
{
    ALL_CRS_INFO.forEach(v => {
        if (v.key == key)
            return v;
    });
    return CRS_INFO_STD;
}

export function MagicCursor(props: {}) {
    const info = useRef(CRS_INFO_STD);
    const [image, setImage] = useState(info.current.standard);
    const [visible, setVisible] = useState(0);

    const context = useContext<CursorContext>(CursorProvider.context);

    const onMouseMove = (e : MouseEvent) => 
    {
        const cursor : HTMLElement|null = document.querySelector(".mcs");
        if (cursor !== null)
        {
            cursor.style.left = `${e.pageX}px`;
            cursor.style.top = `${e.pageY}px`;
        }
    };

    const onScroll = (e : Event) => 
    {
        // console.log(e);
    };

    const onMouseDown = (e : MouseEvent) =>
    {
        if (e.button == 0)
        {
            if (info.current.down !== undefined)
                setImage(info.current.down);
            if (info.current.audio !== undefined)
                info.current.audio.play();
        }
        onMouseMove(e);
    };

    const onMouseUp = (e : MouseEvent) =>
    {
        if (e.button == 0)
        {
            setImage(info.current.standard);
            onMouseMove(e);
        }
    };

    const onMouseOut = (e : MouseEvent) =>
    {
        setVisible(visible + 1);
    };

    const onMouseEnter = (e : MouseEvent) =>
    {
        setVisible(visible - 1);
    };

    const init = () => 
    {
        document.addEventListener("mousedown", onMouseDown);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseover", onMouseMove);
        document.addEventListener("drag", onMouseMove);
        document.addEventListener("dragend", onMouseMove);
        document.addEventListener("scroll", onScroll);
        document.addEventListener("mouseenter", onMouseEnter);
        document.addEventListener("mouseleave", onMouseOut);
        document.addEventListener("mouseup", onMouseUp);
    };

    const setState = (state : CursorState) =>
    {
        const new_info = GetCrsInfo(state);
        info.current = new_info;
        setImage(info.current.standard);
    }

    useEffect(() => {
        setState(context.state);
    }, [context.state]);

    useEffect(() => {
        init();
        return () => {
            document.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseover", onMouseMove);
            document.removeEventListener("drag", onMouseMove);
            document.removeEventListener("dragend", onMouseMove);
            document.removeEventListener("scroll", onScroll);
            document.removeEventListener("mouseenter", onMouseEnter);
            document.removeEventListener("mouseleave", onMouseOut);
            document.removeEventListener("mouseup", onMouseUp);
        }
    }, [props]);

    return (
        <div className='mcs'>
            { visible <= 0 ? <img src={image} className='mcs-icon' /> : null }
        </div>
    );
}